import React, {
  useState,
  useEffect,
  forwardRef,
  useRef,
  useContext,
  useImperativeHandle,
} from 'react';
import NoticeConfigurationStyled from './NoticeConfigurationStyled';
import {
  // TextField,
  // FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  // Select,
  // MenuItem,
  // Checkbox,
  Button,
  useTheme,
} from '@material-ui/core';
import { useSelector } from 'dva';
import MessageML from '@/components/MessageML/index';
import { Context } from '../../AddMarketing';
import { useForm, Controller } from 'react-hook-form';
import { useIntl } from 'umi';
import webStorage from '@/utils/storageManager';
import { SUBACTIVITYTENANTIDS } from '@/constants';

// eslint-disable-next-line no-unused-vars
export default forwardRef((props, fref) => {
  const {
    // control,
    noticeType,
    setNoticeType,
    noticePriority,
    setSelectedNoticeChannels,
    // noticeChannels,
    // setNoticeChannels,
    // smsContentMsg,
    // vxContentMsg,
    opt,
    onSubmit,
  } = props || {};
  const intl = useIntl();
  const { formatMessage } = intl;
  const [openSMS, setOpenSMS] = useState(false);
  const [openWechat, setOpenWechat] = useState(false);
  const [openSub, setOpenSub] = useState(false);
  const [openEmail, setOpenEmail] = useState(false);
  const [openLine, setOpenLine] = useState(false);
  const { ref } = useContext(Context);
  const submitRef = useRef();
  const TENANTID = webStorage.get('TENANT_ID');
  const userAuths = webStorage.get('USER')?.authorities;
  const isMenuEmailMktg = userAuths.includes('MENU_EMAIL_MKTG');
  const clickInput = () => {
    submitRef.current.click();
  };
  useImperativeHandle(ref, () => ({
    // handleSubmit 就是暴露给父组件的方法
    clickInput: clickInput,
  }));

  const theme = useTheme();
  const { handleSubmit, control } = useForm();

  const [vxContent, setVxContent] = useState();
  const [smsContent, setSmsContent] = useState();
  const [subContent, setSubContent] = useState();
  const [emailContent, setEmailContent] = useState();
  const [lineContent, setLineContent] = useState();
  const [msgId, setMsgId] = useState();
  const [subId, setSubId] = useState();
  const [wechatId, setWechatId] = useState();
  const [emailId, setEmailId] = useState();
  const [lineId, setLineId] = useState();

  // 这里没有默认展示
  const [msgChecked, setMsgChecked] = useState(false);
  const [vxChecked, setVxChecked] = useState(false);
  const [subChecked, setSubChecked] = useState(false);
  const [emailChecked, setEmailChecked] = useState(false);
  const [lineChecked, setLineChecked] = useState(false);

  // useEffect(() => {
  //   setMsgChecked(noticeChannels?.some((item) => item.type === '1'));
  //   setVxChecked(noticeChannels?.some((item) => item.type === '2'));
  // }, [noticeChannels]);

  // 活动详情数据
  const sceneMarketingDetail = useSelector(
    (state) => state.sceneMarketing.sceneMarketingDetail,
  );

  //模板消息
  const [noticeChannels, setNoticeChannels] = useState([
    {
      checked: false,
      msgId: '',
      msgContent: '',
      type: '2',
    },
    {
      checked: false,
      msgId: '',
      msgContent: '',
      type: '1',
    },
    {
      checked: false,
      msgId: '',
      msgContent: '',
      type: '3',
    },
    {
      checked: false,
      emailId: '',
      emailContent: '',
      type: '5',
    },
    {
      checked: false,
      lineId: '',
      lineContent: '',
      type: '6',
    },
  ]);
  //关于编辑或预览初始给模板消息赋值
  useEffect(() => {
    if (sceneMarketingDetail?.noticeChannels) {
      const receiveNoticeChannels = sceneMarketingDetail?.noticeChannels;
      const wechatInfo = receiveNoticeChannels.filter((i) => i.type === '2')[0];
      // console.log('wechatInfo', wechatInfo);
      const msgInfo = receiveNoticeChannels.filter((i) => i.type === '1')[0];
      const subInfo = receiveNoticeChannels.filter((i) => i.type === '3')[0];
      const emailInfo = receiveNoticeChannels.filter((i) => i.type === '5')[0];
      const lineInfo = receiveNoticeChannels.filter((i) => i.type === '6')[0];
      const editNoticeChannels = receiveNoticeChannels.map((item) => {
        return { checked: true, ...item };
      });
      // let array = [];
      const newNoticeChannels = noticeChannels?.map((currentValue) => {
        let obj;
        let type = currentValue.type;
        const channel = editNoticeChannels.find((i) => i.type === type);
        if (channel) {
          obj = channel;
        } else {
          obj = currentValue;
        }
        return obj;
      });
      setNoticeChannels(newNoticeChannels);
      if (wechatInfo) {
        // console.log('wechatInfo', wechatInfo);
        setVxChecked(true);
        setVxContent(wechatInfo?.msgContent);
        if (wechatInfo.msgId) {
          setWechatId(Number(wechatInfo?.msgId));
          // console.log('Number(wechatInfo?.msgId)', Number(wechatInfo?.msgId));
        }
      }
      if (msgInfo) {
        // console.log('msgInfo', msgInfo);
        setMsgChecked(true);
        setSmsContent(msgInfo?.msgContent);
        if (msgInfo.msgId) {
          setMsgId(Number(msgInfo?.msgId));
          // console.log('Number(wechatInfo?.msgId)', Number(msgInfo?.msgId));
        }
      }
      if (subInfo) {
        // console.log('msgInfo', msgInfo);
        setSubChecked(true);
        setSubContent(subInfo?.msgContent);
        if (subInfo.msgId) {
          setMsgId(Number(msgInfo?.msgId));
          // console.log('Number(wechatInfo?.msgId)', Number(msgInfo?.msgId));
        }
      }
      if (emailInfo) {
        // console.log('msgInfo', msgInfo);
        setEmailChecked(true);
        setEmailContent(emailInfo?.msgContent);
        if (emailInfo.msgId) {
          setEmailId(Number(emailInfo?.msgId));
        }
      }
      // console.log('Number(wechatInfo?.msgId)', Number(msgInfo?.msgId));
      if (lineInfo) {
        setLineChecked(true);
        setLineContent(lineInfo?.msgContent);
        if (lineInfo.lineId) {
          setLineId(Number(lineInfo?.msgId));
        }
      }
    }
  }, [sceneMarketingDetail]);
  let wechatInfoItem = sceneMarketingDetail?.noticeChannels?.filter(
    (i) => i.type === '2',
  );
  let msgInfoItem = sceneMarketingDetail?.noticeChannels?.filter(
    (i) => i.type === '1',
  );
  let subInfoItem = sceneMarketingDetail?.noticeChannels?.filter(
    (i) => i.type === '3',
  );
  let emailInfoItem = sceneMarketingDetail?.noticeChannels?.filter(
    (i) => i.type === '5',
  );
  let lineInfoItem = sceneMarketingDetail?.noticeChannels?.filter(
    (i) => i.type === '6',
  );
  //拿到最新的值
  const handleSelectChange = (type, changes) => {
    // console.log('changes', changes);
    // console.log('type', type);

    let data = noticeChannels.concat();
    data.map((channel) => {
      if (channel.type === type.toString()) {
        channel.checked = changes.checked;
        channel.msgContent = changes.content;
        channel.msgId = changes.id;
      }
    });
    // console.log('data', data);
    setSelectedNoticeChannels(data);
  };

  return (
    <NoticeConfigurationStyled theme={theme}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="basic-title">
          {formatMessage({ id: 'marketing.scene.holiday.n09.lbl01' })}
        </div>
        <FormLabel component="legend" className="notice-channel-title">
          {/* 通知渠道 */}
          {formatMessage({ id: 'marketing.scene.holiday.n09.lbl02' })}
        </FormLabel>
        <div className="message-wrap">
          {/* 必须选中一项，两个可都选 */}
          {TENANTID !== '11076' && (
            <MessageML
              opt={opt}
              checked={msgChecked}
              setChecked={setMsgChecked}
              content={smsContent}
              setContent={setSmsContent}
              type={1}
              info={msgInfoItem}
              handleSelectChange={handleSelectChange}
              selectedId={msgId}
              setSelectedId={setMsgId}
              open={openSMS}
              setOpen={setOpenSMS}
            ></MessageML>
          )}
          {TENANTID !== '11076' && (
            <MessageML
              opt={opt}
              content={vxContent}
              setChecked={setVxChecked}
              checked={vxChecked}
              setContent={setVxContent}
              type={2}
              info={wechatInfoItem}
              handleSelectChange={handleSelectChange}
              selectedId={wechatId}
              setSelectedId={setWechatId}
              open={openWechat}
              setOpen={setOpenWechat}
            ></MessageML>
          )}
          {SUBACTIVITYTENANTIDS.includes(TENANTID) ? (
            <MessageML
              opt={opt}
              content={subContent}
              setChecked={setSubChecked}
              checked={subChecked}
              setContent={setSubContent}
              type={3}
              info={subInfoItem}
              handleSelectChange={handleSelectChange}
              selectedId={subId}
              setSelectedId={setSubId}
              open={openSub}
              setOpen={setOpenSub}
            ></MessageML>
          ) : (
            ''
          )}
          {isMenuEmailMktg && (
            <MessageML
              // icon="wechat"
              opt={opt}
              info={emailInfoItem}
              handleSelectChange={(type, changes) =>
                handleSelectChange(type, changes)
              }
              content={emailContent}
              setChecked={setEmailChecked}
              checked={emailChecked}
              selectedId={emailId}
              setSelectedId={setEmailId}
              setContent={setEmailContent}
              type={5}
              open={openEmail}
              setOpen={setOpenEmail}
            ></MessageML>
          )}
          {TENANTID === '11076' && (
            <MessageML
              opt={opt}
              info={lineInfoItem}
              handleSelectChange={(type, changes) =>
                handleSelectChange(type, changes)
              }
              content={lineContent}
              setChecked={setLineChecked}
              checked={lineChecked}
              selectedId={lineId}
              setSelectedId={setLineId}
              setContent={setLineContent}
              type={6}
              open={openLine}
              setOpen={setOpenLine}
            ></MessageML>
          )}
        </div>
        <FormLabel component="legend" className="notice-channel-title">
          <span className="label-require">*</span>
          {formatMessage({ id: 'marketing.scene.holiday.n10.lbl01' })}
          {/* 通知规则 */}
        </FormLabel>
        <Controller
          render={(rp) => (
            <RadioGroup
              aria-label="date"
              name="customized-radios"
              className="cycle-select-wrap"
              onChange={(e) => {
                setNoticeType(e.target.value);
                // setCouponUsingThresholdState(e.target.value);
                return rp.onChange(e.target.value);
              }}
              value={noticeType}
            >
              <FormControlLabel
                value="NOTICE_ONE"
                control={<Radio color="primary" disabled={opt === 'detail'} />}
                color="primary"
                label={formatMessage({
                  id: 'marketing.scene.holiday.n10.rdo02',
                })}
                className="all-level-select"
              />
              <div className="notice-channel-box">
                <div className="channel-box-title">
                  <span>
                    {formatMessage({ id: 'marketing.scene.holiday.c10.lbl01' })}
                  </span>
                  <span>
                    {formatMessage({ id: 'marketing.scene.holiday.c10.lbl02' })}
                  </span>
                </div>
                {noticePriority &&
                  noticePriority
                    .filter((item) => item.show)
                    .map((item, index) => {
                      return (
                        <div className="channel-box-content">
                          <span>{index + 1}</span>
                          <span>{item?.noticeChannelName}</span>
                        </div>
                      );
                    })}
              </div>
              <FormControlLabel
                value="NOTICE_ALL"
                control={<Radio color="primary" disabled={opt === 'detail'} />}
                color="primary"
                // label="所有渠道同步通知"
                label={formatMessage({
                  id: 'marketing.scene.holiday.n11.rdo01',
                })}
                className="all-level-select"
              />
              <div className="member-rules">
                {/* 同一个客户，多个渠道通知，有可能会骚扰客户，请谨慎使用 */}
                {formatMessage({ id: 'marketing.scene.holiday.n11.txt02' })}
              </div>
            </RadioGroup>
          )}
          control={control}
          name="couponUsingThreshold"
          rules={{
            required: true,
          }}
        />
        <Button type="submit" ref={submitRef} style={{ display: 'none' }} />
      </form>
    </NoticeConfigurationStyled>
  );
});
